export const REPORT_KIND_LABELS = {
  standalone: { label: "Ponctuel", className: "bg-slate-100 text-slate-600" },
  baseline: { label: "Référence", className: "bg-indigo-100 text-indigo-700" },
  followup: { label: "Contrôle", className: "bg-sky-100 text-sky-700" },
};

export const UPLOAD_MODES = [
  { value: "standalone", label: "Bilan ponctuel", description: "Analyse isolée, sans suivi dans le temps" },
  { value: "baseline", label: "Démarrer un suivi", description: "Premier bilan de référence pour un nouveau suivi" },
  { value: "followup", label: "Contrôle de suivi", description: "Nouveau bilan dans un suivi existant" },
];